import { Injectable } from '@angular/core';
import { LinkTarget as LinkTargetReact } from '@office-start/common-types';
import { LaunchAction as LaunchActionReact } from '@office-start/launcher-types';

import { LinkTarget } from '../constants/link-target.enum';
import { CapabilitiesService } from '../shared-context/capabilities.service';
import { ContextService } from '../shared-context/context.service';
import { LaunchAction, UrlLauncherService } from './url-launcher.service';
import { WindowService } from './window.service';

@Injectable({
    providedIn: 'root'
})
export class WindowUrlLauncherService implements UrlLauncherService {

    constructor(
        private readonly capabilitiesService: CapabilitiesService,
        private readonly contextService: ContextService,
        private readonly windowService: WindowService
    ) {
    }

    public async openUrl(webUrl: string, action: LaunchAction, linkTarget?: LinkTarget, width?: number, height?: number): Promise<void> {
        if (this.capabilitiesService.capabilities.contentLauncherEnabled) {
            import('@office-start/launcher-service').then(
                launchSvc => {
                    launchSvc.launchUrl(webUrl, {action: action as LaunchActionReact, linkTarget: linkTarget as LinkTargetReact});
                }
            );
            return Promise.resolve();
        } else {
            const frameSize = typeof width === 'number' && typeof height === 'number' ? `width=${width},height=${height}` : '';
            this.windowService.nativeWindow.open(webUrl, linkTarget || this.contextService.sharedContext.defaultLinkTarget, frameSize);
            return Promise.resolve();
        }
    }

    public supportsProtocol(_protocol: string): Promise<boolean> {
        return Promise.reject('Method not implemented.');
    }
}
